import { useTranslation } from 'react-i18next';
import { FanguardApiContractsClientAssetModel } from 'src/api/generated';
import { sanitizeFileName, sanitizeUrl } from 'src/utils/sanitize';

import { AssetGrid, AssetGridItem, AssetGridItemFallback, EmptyStateWrapper } from './AssetPicker.styled';
import { isPreviewableAsset } from './utils';

interface AssetSelectGridProps {
  assets: FanguardApiContractsClientAssetModel[];
  selectedAssetId: string | null;
  onSelect: (assetId: string) => void;
}

export const AssetSelectGrid = ({ assets, selectedAssetId, onSelect }: AssetSelectGridProps) => {
  const { t } = useTranslation();

  if (!assets.length) {
    return <EmptyStateWrapper>{t('assets.noAssetsAvailable')}</EmptyStateWrapper>;
  }

  return (
    <AssetGrid data-testid="asset-picker-grid">
      {assets.map((asset) => {
        const name = sanitizeFileName(asset.name || '');
        const previewUrl = isPreviewableAsset(asset) ? sanitizeUrl(asset.url || '') : '';

        return (
          <AssetGridItem
            key={asset.id}
            type="button"
            title={name}
            $isSelected={selectedAssetId === asset.id}
            $preview={previewUrl || undefined}
            onClick={() => onSelect(asset.id || '')}
            data-testid={`asset-picker-grid-item-${asset.id}`}
          >
            {!previewUrl && <AssetGridItemFallback>{name}</AssetGridItemFallback>}
          </AssetGridItem>
        );
      })}
    </AssetGrid>
  );
};
